export const techStack = {
    "Programming Languages": {
        name: "Programming Languages",
        skills: ["C#", "HTML", "CSS", "XAML", "JavaScript", "XML", "Sass", "Swift", "Python", "Java", "SQL"]
    },
    "Platforms & Frameworks": {
        name: "Platforms & Frameworks",
        skills: ["Android", "iOS", ".NET MAUI", "Bootstrap", "React.js", "Flask"]
    },
    "IDE Software": {
        name: "IDE Software",
        skills: ["Visual Studio", "VS Code", "Xcode", "IntelliJ", "DBeaver", "PyCharm"]
    },
    "Git Software": {
        name: "Git Software",
        skills: ["GitHub", "GitHub Desktop", "Bitbucket", "Sourcetree"]
    },
    "Design Tools": {
        name: "Design Tools",
        skills: ["Figma", "Canva", "Affinity", "Adobe Photoshop", "Butter"]
    },
    "Other Tools": {
        name: "Other Tools",
        skills: ["Jira", "Confluence", "Jenkins", "Artifactory", "Scrumwise", "SonarQube"]
    }
}